import {
  ChangeDetectionStrategy, ChangeDetectorRef, Component, Input,
  OnChanges, OnDestroy, OnInit, SimpleChange} from '@angular/core';
import {VRGroupService} from '../../vrgroup.service';
import {_} from '../../../../shared/utils';
import {LandingPageTile} from '../../../../shared/tiles/home-tile.model';
import {animate, keyframes, style, transition, trigger} from '@angular/animations';
import {BaseTrain, RunningTrain, ScheduleTrain, TrainTracking} from '../../common/train';
import {BaseComponent} from '../../../../components/general/base/base.component';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';

import { MapService } from '../../../../shared/map/map.service';
import { LoadingConfig } from '../../../../components/qm-directives/loading.directive';

/**
 * Display train details. In future, this might be able to interact with other components and act as train dashboard.
 * Updates can be implemented when we have support for websocket channels.
 */
@Component({
  selector: 'qm-vrgroup-train-details',
  templateUrl: './train-details.component.html',
  styleUrls: ['./train-details.component.scss'],
  animations: [
    trigger('animatedUpdate', [
      transition('* => *', animate('3500ms', keyframes([
        style({'background-color': 'var(--color-success-80)', offset: 0}),
        style({'background-color': 'transparent', offset: 1.0})
      ])))
    ])
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TrainDetailsComponent extends BaseComponent implements OnInit, OnChanges, OnDestroy {

  /**
   * Currently selected feature
   */
  @Input() public train: RunningTrain;
  /**
   * Current train instance. Maybe Interface would be nice?
   */
  public trainLocation: RunningTrain;
  public trainSchedule: ScheduleTrain;
  public trainTracking: TrainTracking;
  public loadingConfig: LoadingConfig = {
    messages: {
      empty: _('Train information is not available'),
    }
  };
  private oldId: string;
  private trackLocation: number[];
  /**
   * Subscription manager
   * @type {Subject<any>}
   */
  private ngUnsubscribe: Subject<void> = new Subject();

  /**
   * Default constructor
   * @param {VRGroupService} vrGroupService
   * @param {ChangeDetectorRef} changeDetector
   * @param mapService
   */
  constructor(private vrGroupService: VRGroupService,
              private changeDetector: ChangeDetectorRef,
              private mapService: MapService) {
    super();
    this.name = TrainDetailsComponent.getComponentName();
  }

  public static initTile(tile: LandingPageTile) {
    tile.description = _('Details for selected map element');
    tile.icon = 'far fa-info-square';
    tile.title = _('Current feature');
    tile.panel = TrainDetailsComponent.getComponentName();
  }

  private static getComponentName(): string {
    return 'TrainDetails';
  }

  /**
   * Angular initializer hook, subscribe to KoneGIS train data updates
   */
  ngOnInit() {
    // this.oldId = this.train._id;
    // this.useTrain();
    this.vrGroupService.trainTracking$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((data) => {
      if (data.trainId === this.train._id) {
        console.log(data);
        this.trainTracking = data;
        this.vrGroupService.makeTrackSectionLocationRequest(this.trainTracking.station + '_' + this.trainTracking.trackSection);
        this.changeDetector.markForCheck();
      }
    });
    this.vrGroupService.trackSectionLocation$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((data) => {
      if (this.trainTracking && data.section === this.trainTracking.station + '_' + this.trainTracking.trackSection) {
        this.trackLocation = data.location;
      }
    });
  }

  /**
   * Angular change detector, run when component inputs change. Only react to change if
   * a) change is a train
   * b) there was no train selected previously
   * @param changes
   */
  ngOnChanges(changes: { [propKey: string]: SimpleChange }) {
    console.log('TrainDetails', this.train);
    if (this.train._id !== this.oldId) {
      this.useTrain();
    }
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  public getLastTrainSection(): string {
    console.log(this.trainTracking);
    try {
      return this.trainTracking.trackSection;
    } catch (error) {
      return 'Tietoa ei saatavilla';
    }
  }

  public zoomToTrackSection() {
    if (this.trackLocation) {
      this.mapService.flyTo({lat: this.trackLocation[1], lng: this.trackLocation[0]}, 12);
    }
  }

  /**
   * Update current train selection
   */
  private async useTrain() {
    if (this.train._id !== this.oldId) {
      this.loading = true;
    }
    const trainResponses = await Promise.all([
      this.vrGroupService.getTrainSchedule(this.train._id),
      this.vrGroupService.getTrainData(this.train._id),
      this.vrGroupService.getlastTrainTracking(this.train._id)
    ]);
    console.log(trainResponses);
    if (trainResponses[0].isOk) {
      this.trainSchedule = trainResponses[0].data.data[0];
    }
    if (trainResponses[1].isOk) {
      this.trainLocation = trainResponses[1].data.data[0];
    }
    if (trainResponses[2].isOk) {
      this.trainTracking = trainResponses[2].data.data[0];
    }

    this.loading = false;
    this.oldId = this.train._id;
    if (this.trainTracking) {
      this.vrGroupService.makeTrackSectionLocationRequest(this.trainTracking.station + '_' + this.trainTracking.trackSection);
    }
    this.changeDetector.markForCheck();
  }

}
